/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by jessenelson on 2/16/16.
 */
'use strict';
angular.module('prism-ui.components.data').factory('CalendarsResourceFactory',
	function ($resource, EndPointService) {
		return $resource(EndPointService.calendarsEndpoint, {
				showDelivered: '@showDelivered'
			},
			{
				dueDateItems: {
					method: 'GET',
					isArray: true,
					url: EndPointService.calendarsEndpoint + '/partnerDueDateCalendar'
				},
				firstLaunchItems: {
					method: 'GET',
					isArray: true,
					url: EndPointService.calendarsEndpoint + '/firstLaunchDateCalendar'
				},
				ordItems: {
					method: 'GET',
					isArray: true,
					url: EndPointService.calendarsEndpoint + '/originalReleaseDateCalendar'
				},
				liveRecordingsItems: {
					method: 'GET',
					isArray: true,
					url: EndPointService.calendarsEndpoint + '/liveRecordScheduleCalendar'
				}
			}
		);
	});
